exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".my-lead[data-v-e81af6d8]{margin-bottom:15px}.my-message[data-v-e81af6d8]{font-size:90%;text-align:right}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/manager/DbManager/dialogs/DialogDownload.vue"],"names":[],"mappings":"AACA,0BAA0B,kBAAkB,CAC3C,AACD,6BAA6B,cAAc,gBAAgB,CAC1D","file":"DialogDownload.vue","sourcesContent":["\n.my-lead[data-v-e81af6d8]{margin-bottom:15px\n}\n.my-message[data-v-e81af6d8]{font-size:90%;text-align:right\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e81af6d8","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true,"config":{"path":"/home/kss/proj/dn_source/config/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/kss/proj/dn_source/src/sass/core","/home/kss/proj/dn_source/src/sass"],"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/manager/DbManager/dialogs/DialogDownload.vue
// module id = 431
// module chunks = 1